import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./AuthBase.html';
import styles from './AuthBase-hashed.scss';
import GetVersionL10nId from 'gw-portals-platform-js/versionName/GetVersionL10nId';
import {role} from 'effective-features!';

const hashedTemplate = cssUtil.hashTemplate(template, styles);

export default {
    template: hashedTemplate,
    controller: [
        '$scope', 
        '$translate',
        function ($scope, $translate) {
            this.$onInit = function () {                
                const keyWithRole = GetVersionL10nId(`portal.app.versionName.title.${role}`);
                $scope.title = $translate.instant(keyWithRole); 
                // if role specific key is not defined use default
                if ($scope.title === keyWithRole) {
                    $scope.title = $translate.instant(GetVersionL10nId('portal.app.versionName.title'));
                }
            };
        }]
};